import endpoint from './endpoint.json';

export type EndpointEnvKey = keyof typeof endpoint;

type EnvConfig = {
    BASE: string;
    CLOUD_FRONT: string;
    ASW_S3_LINK: string;
    MEDIA_FORGE: string;
    CDN: string;
    URL: string;
    ENVIRONMENT: string;
    SOCKET: string;
    SHORT_URL: string;
    GLOBAL_CONFIG_ID: string;
};

function getEnvKey(): EndpointEnvKey {
    return (process.env.REACT_APP_NODE_ENV || 'development') as EndpointEnvKey;
}

/** Returns Thspian env config from endpoint.json. */
export function getEnvConfig(): EnvConfig {
    const envKey = getEnvKey();
    const config = endpoint as unknown as Record<string, EnvConfig>;
    if (config[envKey]) {
        return config[envKey];
    }
    return config.production ?? config.dev ?? config.development ?? config.qa;
}
